import { SectionHeader } from 'components/RabbitOKRSidePanel/Components/SectionHeaders';

const AlignmentSectionHeader = () => <SectionHeader headerText="Alignment" />;
const DetailsSectionHeader = () => <SectionHeader headerText="Title" />;

export { AlignmentSectionHeader, DetailsSectionHeader };
